import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { ValidationService } from '@kimaya/ngx-base-common-hive';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[requiredValue]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => RequiredValueDirective),
    multi: true,
  }],
})
export class RequiredValueDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (control) {
      return ValidationService.requiredValue(control);
    } else {
      return null;
    }
  }
}
